export const createNamedWrapperReducer = (reducerFunction, reducerName) => (
	(state, action) => {
		const { sourceType } = action;
		const isInitializationCall = state === undefined;

		if (sourceType !== reducerName && !isInitializationCall) {
			return state;
		}

		return reducerFunction(state, action);
	}
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/createNamedWrapperReducer.ts